import type { FollowUpAction } from 'src/types/myFollowUp';

export const IMPLEMENTATION_STATUS_CHOICES = [
  [0, '0%'],
  [25, '25%'],
  [50, '50%'],
  [75, '75%'],
  [100, '100%'],
  [-1, 'Discontinued'],
] as const;

export type ImplementationStatusValue =
  (typeof IMPLEMENTATION_STATUS_CHOICES)[number][0];
export type ImplementationStatusLabel =
  (typeof IMPLEMENTATION_STATUS_CHOICES)[number][1];

export const EMPTY_ACTION_ITEM: FollowUpAction = {
  id: 0,
  type: 'follow-up',
  createdAt: '',
  dueAt: '',
  followUpOwnerName: '',
  followUpOwner: 0,
  implementationStatus: 0,
  lastModifiedAt: '',
  status: 'Open',
  surveyId: 0,
  surveyName: '',
  orgUnits: [],
  kpi: null,
  kpiValue1: null,
  kpiValue2: null,
  statement: null,
};

export const KPI_DISPLAY_CUTOFF = 5;
